import React from 'react';
import { Routes, Route, Link, useNavigate, useLocation } from 'react-router-dom'; // Import useLocation
import { Nav, Container, Row, Col, Button } from 'react-bootstrap';
import { CashStack, TagFill, ClipboardCheck, ClipboardData, FileEarmarkPlus, ArrowLeft, HouseFill, GiftFill, PersonCheckFill } from 'react-bootstrap-icons';
import PriceManagement from './components/PriceManagement';
import DiscountManagement from './components/DiscountManagement';
import ProposalForm from './components/ProposalForm';
import MyProposals from './components/MyProposals';
import ProposalQueue from './components/ProposalQueue';
import AdminDashboardHome from './components/AdminDashboardHome';
import LogDashboard from './components/LogDashboard';
import TrialOfferManagement from './components/TrialOfferManagement';
import WhitelistedUserRoleManagement from './components/WhitelistedUserRoleManagement';
import authService from '../../shared/utils/authService';
import './components/AdminPanel.css'; // Import new CSS file

const AdminPanel = ({ currentUser }) => {
    const navigate = useNavigate();
    const location = useLocation(); // Get current location for active link styling
    const isAdmin = currentUser?.role === 'ADMIN';
    const isManager = currentUser?.role === 'MANAGER';

    const handleLogout = () => {
        authService.logout();
        navigate('/login');
    };

    const adminRoutes = [
        isAdmin && <Route key="pricing" path="pricing" element={<PriceManagement />} />,
        isAdmin && <Route key="discounts" path="discounts" element={<DiscountManagement />} />,
        isAdmin && <Route key="proposals" path="proposals" element={<ProposalQueue />} />,
        isAdmin && <Route key="logs" path="logs" element={<LogDashboard />} />,
        isAdmin && <Route key="sign-up-offer" path="sign-up-offer" element={<TrialOfferManagement />} />,
        isAdmin && <Route key="whitelist" path="whitelist" element={<WhitelistedUserRoleManagement currentUser={currentUser} />} />,
        (isAdmin || isManager) && <Route key="my-proposals" path="my-proposals" element={<MyProposals />} />,
        (isAdmin || isManager) && <Route key="new-proposal" path="new-proposal" element={<ProposalForm />} />,
        <Route key="index" index element={<AdminDashboardHome />} />
    ].filter(Boolean);

    return (
        <Container fluid className="admin-panel-container">
            <Row>
                <Col md={3} lg={2} className="admin-sidebar">
                    <Nav className="flex-column">
                        <Nav.Link as={Link} to="" className={`d-flex align-items-center ${location.pathname === '/admin' ? 'active' : ''}`}><HouseFill className="me-2" />Admin Home</Nav.Link>
                        {isAdmin && <Nav.Link as={Link} to="pricing" className={`d-flex align-items-center ${location.pathname.includes('/admin/pricing') ? 'active' : ''}`}><CashStack className="me-2" />Pricing</Nav.Link>}
                        {isAdmin && <Nav.Link as={Link} to="discounts" className={`d-flex align-items-center ${location.pathname.includes('/admin/discounts') ? 'active' : ''}`}><TagFill className="me-2" />Discounts</Nav.Link>}
                        {isAdmin && <Nav.Link as={Link} to="proposals" className={`d-flex align-items-center ${location.pathname.includes('/admin/proposals') ? 'active' : ''}`}><ClipboardCheck className="me-2" />Proposals</Nav.Link>}
                        {isAdmin && <Nav.Link as={Link} to="logs" className={`d-flex align-items-center ${location.pathname.includes('/admin/logs') ? 'active' : ''}`}><ClipboardData className="me-2" />Activity Logs</Nav.Link>}
                        {isAdmin && <Nav.Link as={Link} to="sign-up-offer" className={`d-flex align-items-center ${location.pathname.includes('/admin/sign-up-offer') ? 'active' : ''}`}><GiftFill className="me-2" />Sign-up Offer</Nav.Link>}
                        {isAdmin && <Nav.Link as={Link} to="whitelist" className={`d-flex align-items-center ${location.pathname.includes('/admin/whitelist') ? 'active' : ''}`}><PersonCheckFill className="me-2" />Whitelisted User Role Management</Nav.Link>}
                        
                        {(isAdmin || isManager) && <Nav.Link as={Link} to="my-proposals" className={`d-flex align-items-center ${location.pathname.includes('/admin/my-proposals') ? 'active' : ''}`}><ClipboardData className="me-2" />My Proposals</Nav.Link>}
                        {(isAdmin || isManager) && <Nav.Link as={Link} to="new-proposal" className={`d-flex align-items-center ${location.pathname.includes('/admin/new-proposal') ? 'active' : ''}`}><FileEarmarkPlus className="me-2" />New Proposal</Nav.Link>}
                    </Nav>
                </Col>
                <Col md={9} lg={10} className="admin-main-content">
                    <div className="admin-content-header">
                        <h2 className="mb-0">Admin Panel</h2>
                        <div>
                            <Link to="/">
                                <Button variant="secondary" className="me-2 d-flex align-items-center">
                                    <ArrowLeft className="me-2" />Back to User Page
                                </Button>
                            </Link>
                            <Button variant="outline-danger" onClick={handleLogout}>Logout</Button>
                        </div>
                    </div>
                    <Routes>
                        {adminRoutes}
                    </Routes>
                </Col>
            </Row>
        </Container>
    );
};

export default AdminPanel;
